@if (item) {
  <a
    class="nav-item"
    [attr.data-cy]="item.dataCy"
    [attr.title]="item.title | transloco"
    [href]="item.link">
    {{ item.title | transloco }}
  </a>
}
